<template>
  <v-card>
    <v-card-title class="align-start">
      <span>{{title}}</span>
    </v-card-title>

    <v-card-text>
        <v-data-table
          :items-per-page="itemsPerPage"
          :headers="headers"
          :items="assignment"
          hide-default-footer
          :search="search"
        >
        </v-data-table>

        <!-- Table -->
    </v-card-text>
  </v-card>
</template>

<script>

export default {
  components: {

  },
  mounted() {
    
  },
  computed:{
    assignment(){
      return this.$store.getters.getAssignmentStat
    },
    title(){
        return 'My Assignment Performance Overview'
    },
    staff(){
      return this.$store.getters.isStaff
    },
  },
  data() {

    return {
        search: '',
        itemsPerPage: 20,
        headers: [
        {
          text: 'Assignment',
          align: 'start',
          sortable: false,
          value: 'assignment_assignmentName',
          width: 120 
        },
        { text: 'Score', value: 'score', width: 100 },
        { text: 'Narration', value: 'percentile' }
      ],
    }
  },
  methods: {
  }
}
</script>
